import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Page from '../Page.js';
import uiManager from '../../../config/ui.js';
import PAGES from '../../data/PagesConstants.js';
import PageContentWrapper from "../../components/PageContentWrapper.js";
import FormPartial from './FormPartial.js';
import Cluster from '../../models/Cluster.js';
import { getApi } from '../../api/endpoints.js';
import { toast } from 'react-toastify';

const New = (props) => {
  const navigate = useNavigate();
  const [cluster, setCluster] = useState(new Cluster());
  const [createApi] = getApi('createCluster');

  const createRecord = async (params) => {
    try {
      await createApi(params).unwrap();
      toast.success("Cluster Created Successfully");
      navigate("/clusters");
    } catch (error) {
      toast.error(error.data?.message || "Something went wrong !");
      let clusterObj = new Cluster(cluster);
      clusterObj.set_api_errors(error?.data?.data?.errors);
    }
  }

  const handleSubmitFunction = () => {
    try{
      createRecord(new Cluster(cluster).toApiJson());
    } catch(error){
      setCluster(new Cluster(cluster));
    }
  }

  const handleCancelFunction = () => {
    navigate('/clusters');
  }

  return <Page
      uiPage={uiManager.getUiPage(PAGES.NewClusterPage.name)}
      breadcrumbs={[{ label: "Home", url: '/dashboard' }, { label: "Cluster", url: '/clusters' }, { label: "Add New Cluster" }]}
      className={'new-cluster-page'}
    >
      <PageContentWrapper contentHeading={"Create New Cluster"}>
        <div className='m-3'>
          <div className='mb-4 col'>
            <form className="row g-3" autoComplete="off">
              <FormPartial cluster={cluster} setCluster={setCluster} />
              <div className='mb-4 col'>
                <div>
                  <button style={{ float: 'inline-start' }} type="button" className="btn btn-voltup-theme" onClick={handleCancelFunction}>
                    Back
                  </button>
                  <button type="button" className="btn btn-voltup-theme ms-3" onClick={handleSubmitFunction}>
                    Create
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </PageContentWrapper>
    </Page>
}

export default New;
